module.exports = __webpack_public_path__ + "media/images/icons/page_split-ce922371772a32450b00e910ee98c5dd.svg";